import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';
import { Typography } from '@mui/material';

export const AdminContainer = styled(Box)(({ theme }) => ({
  borderRadius: theme.spacing(2),
  marginTop: theme.spacing(1),
  display: 'flex',
  width: '100%',
  height: 'calc(100vh - 100px)', // Match other pages - account for top bar
  overflow: 'hidden',
  transition: 'all 0.3s ease-in-out',
}));

export const ErrorMessage = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(10),
}));

export const ContentBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  height: 'calc(100vh - 100px)', // Match container height constraint
  flex: '1 1 100%',
  transition: 'flex 0.3s ease-in-out',
  backgroundColor: theme.palette.background.default,
  borderRadius: theme.spacing(2),
  overflow: 'auto', // Enable scrolling
  '&.drawer-open': {
    flex: '1 1 calc(100% - 400px)',
  },
}));
